<template>
  <div class="shopSearchForm">
    <div id="fixedContainer" class="shopSearchForm__spFixedContainer spOnly">
      <div class="shopSearchForm__spFixedContent">
        <div class="shopSearchForm__spFixedAreaContent">
          <i class="search icon"></i>
          <span>{{ areaLabel(form.model.area, this.areas) }}</span>
        </div>
        <div class="shopSearchForm__spFixedFormOpenButton">
          <button class="ui button" @click="showSearchForm()">変更</button>
        </div>
      </div>
    </div>
    <div class="shopSearchForm__formContainer" id="searchForm">
      <form class="ui form" @submit.prevent="search()">
        <div class="shopSearchForm__header spOnly">
          <span>検索条件</span>
          <button class="ui button" @click.prevent="hideSearchForm()">閉じる</button>
        </div>
        <div class="shopSearchForm__freeTextContainer">
          <label class="shopSearchForm__label">フリーワード</label>
          <div class="shopSearchForm__inputContainer">
            <input type="text" v-model="form.model.q" placeholder="フリーワードで検索">
          </div>
        </div>

        <div class="shopSearchForm__areaContainer">
          <label class="shopSearchForm__label">都道府県・エリア</label>
          <div class="shopSearchForm__inputContainer">
            <dropdown class="shopSearchForm__areaDropdown" v-model="form.model.prefecture"  @change="onPrefectureChange()" :placeholder="'都道府県'">
              <option value=""></option>
              <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
            </dropdown>

            <div class="pcOnly">
            　<label class="shopSearchForm__areaDropdownLabel">エリア</label>
              <dropdown class="shopSearchForm__areaDropdown" v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア'">
                <option value="">エリア</option>
                <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
              </dropdown>

              <label class="shopSearchForm__areaDropdownLabel">エリア詳細</label>
              <dropdown class="shopSearchForm__areaDropdown" ref="areaDetail" v-model="form.model.area_details" @change="onAreaDetailChange()" :placeholder="'指定しない'" :max-size="-1"></dropdown>

                <label class="shopSearchForm__areaDropdownLabel">駅</label>
                <dropdown class="shopSearchForm__areaDropdown" ref="station" v-model="form.model.stations" :placeholder="'指定しない'" :max-size="-1"></dropdown>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__areaAccordionContainer spOnly">
          <div class="title" @click="toggleAreaAccordion('area')" :class="{ 'active': openedAccordions['area'] }">
            <span>エリア選択</span>
            <i class="dropdown icon"></i>
          </div>
          <div class="content" :class="{ 'active': openedAccordions['area'] }">
            <div v-if="area.value !== ''" class="shopSearchForm__areaAccordionContainer__area"
                 v-for="area in areaOptions" :key="area.label">
              <div class="flex-container">
                <input type="radio" name="areaGroup" :value="area.value" @change="onAreaChange()" v-model="form.model.area">
                <div class="title" @click="clickArea(area.value)" :class="{ 'active': openedAccordions[area.value] }">
                  <span>{{ area.label }}</span>
                  <i class="dropdown icon"></i>
                </div>
              </div>
              <div class="content" :class="{ 'active': openedAccordions[area.value] }">
                <div class="ui checkbox" v-for="detail in areaDetailOptions[area.value]" :key="detail.value">
                  <input type="checkbox" :id="`detail-${detail.value}`" :value="detail.value" v-model="form.model.area_details" @click="onAreaDetailClick(area.value)" @change="onAccordionAreaDetailChange()">
                  <label :for="`detail-${detail.value}`">{{ detail.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__stationAccordionContainer spOnly">
          <div class="title" @click="toggleAreaAccordion('station')" :class="{ 'active': openedAccordions['station'] }">
            <span>駅選択</span>
            <i class="dropdown icon"></i>
          </div>
          <div class="content" :class="{ 'active': openedAccordions['station'] }">
            <div class="ui checkbox" v-for="station in stationOptions" :key="station.value">
                <input type="checkbox" :id="`station-${station.value}`" :value="station.value" v-model="form.model.stations">
                <label :for="`station-${station.value}`">{{ station.label }}</label>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__shopTypeContainer">
          <label class="shopSearchForm__label">会場の種類</label>
          <div class="shopSearchForm__inputContainer">
            <div v-for="shopType in consts.SHOP_TYPE" :key="shopType.value" class="ui checkbox">
              <input type="checkbox" :id="`shop-type-${shopType.value}`" :value="shopType.value" v-model="form.model.shop_types">
              <label :for="`shop-type-${shopType.value}`">{{ shopType.label }}</label>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__peopleContainer">
          <label class="shopSearchForm__label">人数</label>
          <div class="shopSearchForm__inputContainer">
            <div class="shopSearchForm__peopleDropdownContainer">
              <dropdown class="shopSearchForm__peopleMinDropdown" v-model="form.model.people_from" :options="consts.SHOP_PEOPLE" :placeholder="'人数下限'">
                <option value="">下限なし</option>
              </dropdown>
              <span class="shopSearchForm__peopleBetweenText">〜</span>
              <dropdown class="shopSearchForm__peopleMaxDropdown" v-model="form.model.people_to" :options="consts.SHOP_PEOPLE" :placeholder="'上限なし'">
                <option value="">上限なし</option>
              </dropdown>
            </div>
            <div class="shopSearchForm__seatCondition">
              <div class="ui checkbox radio">
                <input type="radio" v-model="form.model.people_type" name="people_type" value="1">
                <label>着席</label>
              </div>
              <div class="ui checkbox radio">
                <input type="radio" v-model="form.model.people_type" name="people_type" value="2">
                <label>立席</label>
              </div>
              <div class="ui checkbox radio">
                <input type="radio" v-model="form.model.people_type" name="people_type" value="">
                <label>こだわらない</label>
              </div>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__budgetContainer">
          <label class="shopSearchForm__label">予算</label>
          <div class="shopSearchForm__inputContainer">
            <div class="shopSearchForm__budgetDropdownContainer">
              <dropdown class="shopSearchForm__budgetMinDropdown" v-model="form.model.price_from" :placeholder="'下限なし'">
                <option value="">下限なし</option>
                <option value="3000">3,000円</option>
                <option value="4000">4,000円</option>
                <option value="5000">5,000円</option>
                <option value="6000">6,000円</option>
                <option value="7000">7,000円</option>
                <option value="8000">8,000円</option>
                <option value="9000">9,000円</option>
                <option value="10000">10,000円</option>
              </dropdown>
              <span class="shopSearchForm__budgetBetweenText">〜</span>
              <dropdown class="shopSearchForm__budgetMaxDropdown" v-model="form.model.price_to" :placeholder="'上限なし'">
                <option value="">上限なし</option>
                <option value="3000">3,000円</option>
                <option value="4000">4,000円</option>
                <option value="5000">5,000円</option>
                <option value="6000">6,000円</option>
                <option value="7000">7,000円</option>
                <option value="8000">8,000円</option>
                <option value="9000">9,000円</option>
                <option value="10000">10,000円</option>
              </dropdown>
            </div>
            <div class="shopSearchForm__budgetOptionContainer">
              <div class="shopSearchForm__budgetOptionItem">
                <div class="ui checkbox">
                  <input type="checkbox" v-model="form.model.drink_flg" value="true">
                  <label>飲み放題込み</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__genreContainer">
          <label class="shopSearchForm__label">料理ジャンル</label>
          <div class="shopSearchForm__inputContainer">
            <div v-for="genre in consts.SHOP_GENRE" :key="genre.value" class="ui checkbox">
              <input type="checkbox" :id="`genre-${genre.value}`" :value="genre.value" v-model="form.model.genres">
              <label :for="`genre-${genre.value}`">{{ genre.label }}</label>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__smokingContainer">
          <label class="shopSearchForm__label">喫煙</label>
          <div class="shopSearchForm__inputContainer">
            <div v-for="smoking_type in consts.SMOKING" :key="smoking_type.value" class="ui checkbox radio">
              <input type="radio" v-model="form.model.smoking_type" name="smoking_type" :value=smoking_type.value>
              <label>{{ smoking_type.label }}</label>
            </div>
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.smoking_type" name="smoking_type" :value="''">
              <label>指定しない</label>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__featureContainer ui accordion">
          <div class="title">
            <label class="shopSearchForm__featureLabel">こだわり<i class="dropdown icon"></i></label>
          </div>
          <div class="shopSearchForm__inputContainer content">
            <div class="shopSearchForm__featureList">
              <label class="shopSearchForm__featureListLabel">部屋</label>
              <div v-for="feature in consts.SHOP_FEATURES.slice(0, 4)" :key="feature" class="ui checkbox">
                <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
                <label :for="`feature-${feature}`">{{ feature }}</label>
              </div>
            </div>
            <div class="shopSearchForm__featureList">
              <label class="shopSearchForm__featureListLabel">席タイプ</label>
              <div v-for="feature in consts.SHOP_FEATURES.slice(4, 9)" :key="feature" class="ui checkbox">
                <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
                <label :for="`feature-${feature}`">{{ feature }}</label>
              </div>
            </div>
            <div class="shopSearchForm__featureList">
              <label class="shopSearchForm__featureListLabel">設備</label>
              <div v-for="feature in consts.SHOP_FEATURES.slice(9, 17)" :key="feature" class="ui checkbox">
                <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
                <label :for="`feature-${feature}`">{{ feature }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="shopSearchForm__submitButtonContainer">
          <div class="shopSearchForm__inputContainer">
            <div class="shopSearchForm__submitButtonList">
              <button class="ui gray button shopSearchForm__submitClearButton" @click.prevent="clear">クリア</button>
              <button class="ui orange button shopSearchForm__submitSearchButton" :class="{'disabled loading': form.waiting && shops.length === 0}">検索する</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

export default {
    data: function() {
        var query = _.defaults(this.query(), {
            people_type: '',
            area_details: [],
            people_from: '',
            price_to: '',
            prefecture: '',
            shop_types: [],
            genres: [],
            features: [],
        });
        if (window.data.path_params.prefecture) {
            query.prefecture = window.data.path_params.prefecture;
        }
        if (window.data.path_params.area_id) {
            query.area = window.data.path_params.area_id;
        }
        if (window.data.path_params.area_detail_id) {
            query.area_details = window.data.path_params.area_detail_id;
        }
        if (window.data.path_params.station_id) {
            query.stations = window.data.path_params.station_id;
        }
        if (window.data.path_params.yen_or_people === "people") {
            query.people_from = window.data.path_params.count;
        }
        if (window.data.path_params.yen_or_people === "yen") {
            query.price_to = window.data.path_params.count;
        }
        if (window.data.path_params.shop_type) {
            query.shop_types = [this.getShopTypeValue(window.data.path_params.shop_type)];
        }
        if (window.data.path_params.genres) {
            query.genres = window.data.path_params.genres.split(',');
        }
        if (window.data.path_params.features) {
            query.features = window.data.path_params.features.split(',');
        }
        if (window.data.path_params.people_count && window.data.path_params.yen_count) {
            query.people_from = window.data.path_params.people_count;
            query.price_to = window.data.path_params.yen_count;
        }
        return {
            form: this.createForm(query),
            pager: this.createPager(16),
            shops: [],
            currentQuery: {},
            areaOptions: [],
            areaDetailOptions: {},
            stationOptions: {},
            openedAccordions: {},
            areas: [],
            areaDetails: [],
            stations: [],
        };
    },
    mounted: function() {
        var multiSelectFields = ['area_details', 'stations', 'shop_types', 'genres', 'features'];
        _.forEach(multiSelectFields, function(field) {
            if (!this.form.model[field]) {
                this.form.model[field] = [];
            } else if (_.isString(this.form.model[field])) {
                this.form.model[field] = this.form.model[field].split(',');
            }
        }.bind(this));

        $('.ui.checkbox').checkbox();
        $('.ui.accordion').accordion();
        $('#searchForm').addClass('hide')
        $('#fixedContainer').show();

        this.createForm().get('/api/areas/', function(response) {
            _.forEach(response.data, function(each) {
                this.areas.push(each);
            }.bind(this));
            const selectedPrefecture = this.form.model.prefecture;
            this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
        });

        this.createForm().get('/api/area_details/', function(response) {
            _.forEach(response.data, function(each) {
                this.areaDetails.push(each);
            }.bind(this));
            this.onAreaChange(true);
        });

        this.createForm().get('/api/stations/', function(response) {
            _.forEach(response.data, function(each) {
                this.stations.push(each);
            }.bind(this));
            this.onAreaDetailChange(true);
        });

        $(window).scroll(function () {
          if ($(window).scrollTop() > $('.siteHeader').outerHeight()) {
            $('#fixedContainer').addClass('fixed');
          } else {
            $('#fixedContainer').removeClass('fixed');
          }
        });
    },
    methods: {
        showSearchForm: function() {
            $('#fixedContainer').hide();
            $('#searchForm').removeClass('hide');
            $('html,body').animate({scrollTop: $('.siteHeader').outerHeight()}, 100);
        },
        hideSearchForm: function() {
            $('#fixedContainer').show();
            $('#searchForm').addClass('hide');
        },
        onPrefectureChange() {
          const selectedPrefecture = this.form.model.prefecture;
          if (selectedPrefecture === '') {
              this.form.model.area = null;
              this.areaOptions = [];
          } else {
              this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
              if (this.areaOptions.length > 0) {
                  this.form.model.area = null;
              }
          }
        },
        onAreaChange: function(opt_keepAreaDetail) {
            if (!opt_keepAreaDetail) {
                this.form.model.area_details = [];
                this.form.model.stations = [];
            }
            this.$refs.areaDetail.setOptions(this.areaDetailsOf(this.form.model.area, this.areaDetails));
            this.$refs.station.setOptions([]);
            this.stationOptions = {};
        },
        onAreaDetailChange: function(keepStation) {
            if (!keepStation) {
                this.form.model.stations = [];
            }
            this.$refs.station.setOptions(this.stationsOfAreaDetail(this.form.model.area_details, this.stations));
            this.stationOptions = this.stationsOfAreaDetail(this.form.model.area_details, this.stations);
        },
        onAreaDetailClick(selectedAreaValue) {
          const areaId = Number(this.form.model.area);
          if (areaId !== selectedAreaValue) {
            this.form.model.area_details = [];
          }
          this.form.model.area = selectedAreaValue;
        },
        onAccordionAreaDetailChange: function() {
            this.stationOptions = this.stationsOfAreaDetail(this.form.model.area_details, this.stations);
        },
        getShopTypeValue: function(shopType) {
            const shopTypes = [
                {value: 1, label: 'izakaya'},
                {value: 3, label: 'restaurant_cafe'},
                {value: 4, label: 'hotel_banquet'},
                {value: 5, label: 'party_space'},
                {value: 6, label: 'wedding'},
                {value: 7, label: 'guesthouse_ceremony'},
                {value: 8, label: 'club'},
                {value: 9, label: 'meeting_room'},
                {value: 10, label: 'sonota'},
            ];
            return shopTypes.find(each => each.label === shopType).value;
        },
      search: function() {
            var query = [];
            if (this.form.model.q) {
                query.push('q=' + this.form.model.q);
            }
            if (this.form.model.prefecture) {
                query.push('prefecture=' + this.form.model.prefecture);
            }
            if (this.form.model.area) {
                query.push('area=' + this.form.model.area);
            }
            if (this.form.model.area_details) {
              query.push('area_details=' + this.form.model.area_details);
            }
            if (this.form.model.stations) {
              query.push('stations=' + this.form.model.stations);
            }
            if (this.form.model.shop_types) {
              query.push('shop_types=' + this.form.model.shop_types);
            }
            if (this.form.model.people_from) {
                query.push('people_from=' + this.form.model.people_from);
            }
            if (this.form.model.people_to) {
                query.push('people_to=' + this.form.model.people_to);
            }
            if (this.form.model.people_type) {
                query.push('people_type=' + this.form.model.people_type);
            }
            if (this.form.model.price_from) {
                query.push('price_from=' + this.form.model.price_from);
            }
            if (this.form.model.price_to) {
                query.push('price_to=' + this.form.model.price_to);
            }
            if (this.form.model.drink_type) {
                query.push('drink_type=' + this.form.model.drink_type);
            }
            if (this.form.model.genres) {
                query.push('genres=' + this.form.model.genres);
            }
            if (this.form.model.smoking_type) {
                query.push('smoking_type=' + this.form.model.smoking_type);
            }
            if (this.form.model.features) {
                query.push('features=' + this.form.model.features);
            }
            window.location.href = '/shops/search?' + _.join(query, '&');
        },
        clear: function () {
           this.form.model = {
              people_type: '',
              area_details: [],
              stations: [],
              people_from: '',
              price_to: '',
              prefecture: '',
              shop_types: [],
              genres: [],
              features: [],
              smoking_type: '',
            };
        },
        toggleAreaAccordion: function(id) {
          this.$set(this.openedAccordions, id, !this.openedAccordions[id]);
        },
        clickArea: function(areaId) {
          this.toggleAreaAccordion(areaId);
          this.$set(this.areaDetailOptions, areaId, this.areaDetailsOf(areaId, this.areaDetails));
        },
    }
};
</script>